import LayoutCentered from '@/layout/LayoutCentered';


export default [
  {
    // Layout 2
    path: '/recordings',
    component: LayoutCentered,
    meta: {
      auth: true,
    },
    children: [
          {
            path: '',
            component: () => import('@/components/pages/calls/Calls'),
          },
        ],
  },
];
